import {EpLayer} from "./layer";
import {
    farInventoryLocationPointStyle, inventoryLocationPointStyle,
} from "../styles/inventory-locations";

export class EpInventoryLocationPoints extends EpLayer {
    constructor(map) {
        super(map);

        this.style = inventoryLocationPointStyle;
        this.farStyle = farInventoryLocationPointStyle;

        this.title = 'Punkty';
        this.name = 'location_points';

        return this;
    }
}
